import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileCollectorHelpGetStartedPage() {
  const t = useTranslations('collectors_help.get_started');
  const [openSections, setOpenSections] = useState({
    creatingAccount: false,
    customizingProfile: false,
    whoCanSell: false,
    benefitsRegistered: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  function withoutSectionNumber(title) {
    return title.replace(/^\d+\)\s*/, '');
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/collector-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('creatingAccount')}
            aria-expanded={openSections.creatingAccount}
          >
            <h2>{withoutSectionNumber(t('sections.creating_account.title'))}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.creatingAccount ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.creatingAccount && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.creating_account.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.creating_account.how_to_sign_up_title')}</h3>
                <ul>
                  <li>{t('sections.creating_account.how_to_sign_up_list_1')}</li>
                  <li>{t('sections.creating_account.how_to_sign_up_list_2')}</li>
                  <li>{t('sections.creating_account.how_to_sign_up_list_3')}</li>
                  <li>{t('sections.creating_account.how_to_sign_up_list_4')}</li>
                  <li>{t('sections.creating_account.how_to_sign_up_list_5')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.creating_account.tip_title')}</h3>
                <p>{t('sections.creating_account.tip_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('customizingProfile')}
            aria-expanded={openSections.customizingProfile}
          >
            <h2>{withoutSectionNumber(t('sections.customizing_profile.title'))}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.customizingProfile ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.customizingProfile && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.customizing_profile.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.customizing_profile.edit_basic_title')}</h3>
                <ul>
                  <li>{t('sections.customizing_profile.edit_basic_list_1')}</li>
                  <li>{t('sections.customizing_profile.edit_basic_list_2')}</li>
                  <li>{t('sections.customizing_profile.edit_basic_list_3')}</li>
                  <li>{t('sections.customizing_profile.edit_basic_list_4')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.customizing_profile.mode_theme_title')}</h3>
                <p>{t('sections.customizing_profile.mode_theme_p1')}</p>
                <ul>
                  <li>{t('sections.customizing_profile.mode_theme_list_1')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.customizing_profile.suarte_road_title')}</h3>
                <p>{t('sections.customizing_profile.suarte_road_p1')}</p>
                <ul>
                  <li>{t('sections.customizing_profile.suarte_road_list_1')}</li>
                  <li>{t('sections.customizing_profile.suarte_road_list_2')}</li>
                  <li>{t('sections.customizing_profile.suarte_road_list_3')}</li>
                </ul>
                <p>{t('sections.customizing_profile.suarte_road_p2')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.customizing_profile.change_password_title')}</h3>
                <p>{t('sections.customizing_profile.change_password_p1')}</p>
                <ul>
                  <li>{t('sections.customizing_profile.change_password_list_1')}</li>
                  <li>{t('sections.customizing_profile.change_password_list_2')}</li>
                  <li>{t('sections.customizing_profile.change_password_list_3')}</li>
                  <li>{t('sections.customizing_profile.change_password_list_4')}</li>
                  <li>{t('sections.customizing_profile.change_password_list_5')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.customizing_profile.note_title')}</h3>
                <p>{t('sections.customizing_profile.note_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whoCanSell')}
            aria-expanded={openSections.whoCanSell}
          >
            <h2>{withoutSectionNumber(t('sections.who_can_sell.title'))}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whoCanSell ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whoCanSell && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.who_can_sell.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.who_can_sell.primary_market_title')}</h3>
                <ul>
                  <li>{t('sections.who_can_sell.primary_market_list_1')}</li>
                  <li>{t('sections.who_can_sell.primary_market_list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.who_can_sell.secondary_market_title')}</h3>
                <p>{t('sections.who_can_sell.secondary_market_p1')}</p>
                <ul>
                  <li>{t('sections.who_can_sell.secondary_market_list_1')}</li>
                  <li>{t('sections.who_can_sell.secondary_market_list_2')}</li>
                  <li>{t('sections.who_can_sell.secondary_market_list_3')}</li>
                  <li>{t('sections.who_can_sell.secondary_market_list_4')}</li>
                </ul>
                <p>{t('sections.who_can_sell.secondary_market_p2')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('benefitsRegistered')}
            aria-expanded={openSections.benefitsRegistered}
          >
            <h2>{withoutSectionNumber(t('sections.benefits_registered.title'))}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.benefitsRegistered ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.benefitsRegistered && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.benefits_registered.p1')}</p>
              <ul>
                <li>{t('sections.benefits_registered.list_1')}</li>
                <li>{t('sections.benefits_registered.list_2')}</li>
                <li>{t('sections.benefits_registered.list_3')}</li>
                <li>{t('sections.benefits_registered.list_4')}</li>
                <li>{t('sections.benefits_registered.list_5')}</li>
                <li>{t('sections.benefits_registered.list_6')}</li>
                <li>{t('sections.benefits_registered.list_7')}</li>
                <li>{t('sections.benefits_registered.list_8')}</li>
                <li>{t('sections.benefits_registered.list_9')}</li>
              </ul>
              <p>{t('sections.benefits_registered.p2')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.benefits_registered.suarte_plus_title')}</h3>
                <p>{t('sections.benefits_registered.suarte_plus_p1')}</p>
                <ul>
                  <li>{t('sections.benefits_registered.suarte_plus_list_1')}</li>
                  <li>{t('sections.benefits_registered.suarte_plus_list_2')}</li>
                  <li>{t('sections.benefits_registered.suarte_plus_list_3')}</li>
                  <li>{t('sections.benefits_registered.suarte_plus_list_4')}</li>
                  <li>{t('sections.benefits_registered.suarte_plus_list_5')}</li>
                </ul>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
